'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var styleConfig = {
  icons: {
    TableHeadingCell: {
      sortDescendingIcon: '▼',
      sortAscendingIcon: '▲'
    }
  },
  classNames: {
    Cell: 'griddle-cell',
    Filter: 'griddle-filter',
    Loading: 'griddle-loadingResults',
    NextButton: 'griddle-next-button',
    NoResults: 'griddle-noResults',
    PageDropdown: 'griddle-page-select',
    Pagination: 'griddle-pagination',
    PreviousButton: 'griddle-previous-button',
    Row: 'griddle-row',
    RowDefinition: 'griddle-row-definition',
    Settings: 'griddle-settings',
    SettingsToggle: 'griddle-settings-toggle',
    Table: 'griddle-table',
    TableBody: 'griddle-table-body',
    TableHeading: 'griddle-table-heading',
    TableHeadingCell: 'griddle-table-heading-cell',
    TableHeadingCellAscending: 'griddle-heading-ascending',
    TableHeadingCellDescending: 'griddle-heading-descending'
  },
  styles: {}
};

exports.default = {
  styleConfig: styleConfig,

  pageProperties: {
    currentPage: 1,
    pageSize: 10
  },
  enableSettings: true,
  textProperties: {
    filterPlaceholder: 'Filter',
    next: 'Next',
    previous: 'Previous',
    settingsToggle: 'Settings'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/dist/module/core/initialState.js
// module id = 1292
// module chunks = 1